import { Table } from '@quero-delivery/quero-components-web';
import { useNavigate } from 'react-router-dom';
import { format } from '@querodelivery/qd-date-helper';
import { Checkbox } from '@/_components/checkbox';
import { image } from '@/Themes/Images';
import { normalizeStatus } from '@/Utils/FnUtils';
import styles from './styles.module.scss';
import { ENUM_DELIVERYMAN_STATUS } from '@/_constants/enums';
import type { OnlineDeliveryman } from '@/_features/dashboard/types';

interface DeliverymanRowTableProps {
  deliveryman: OnlineDeliveryman;
  isSelected: () => boolean;
  onSelectedChange: () => void;
}

function DeliverymanRowTable({
  deliveryman,
  isSelected,
  onSelectedChange,
}: DeliverymanRowTableProps) {
  const navigate = useNavigate();

  const DELIVERY_MAN_ICON_BY_STATUS: Record<ENUM_DELIVERYMAN_STATUS, string> = {
    [ENUM_DELIVERYMAN_STATUS.DISPONIVEL]: image.marker_disponivel,
    [ENUM_DELIVERYMAN_STATUS.ENTREGA_ASSOCIADA]:
      image.marker_indo_estabelecimento,
    [ENUM_DELIVERYMAN_STATUS.EM_CORRIDA]: image.marker_entregando,
    [ENUM_DELIVERYMAN_STATUS.OFFLINE]: '',
    [ENUM_DELIVERYMAN_STATUS.BLOQUEADO]: '',
    [ENUM_DELIVERYMAN_STATUS.PRECADASTRO]: '',
    [ENUM_DELIVERYMAN_STATUS.REPROVADO]: '',
    [ENUM_DELIVERYMAN_STATUS.EXCLUIDO]: '',
  };

  return (
    <Table.Row className="pointer">
      <Table.Cell
        className={styles.rowName}
        onClick={() => navigate(`/entregadores/${deliveryman._id}`)}
      >
        <img
          src={DELIVERY_MAN_ICON_BY_STATUS[deliveryman.status]}
          height={20}
          alt="iconStatus"
        />
        {deliveryman.deliverymanName}
      </Table.Cell>
      <Table.Cell data-testid={deliveryman.status} role="button">
        {normalizeStatus(deliveryman.status)}
      </Table.Cell>
      <Table.Cell>
        {deliveryman.lastDelivery
          ? format(
              new Date(deliveryman.lastDelivery as unknown as Date),
              'dd/MM/yyyy HH:mm',
            )
          : ''}
      </Table.Cell>
      <Table.Cell>
        {deliveryman.status === ENUM_DELIVERYMAN_STATUS.DISPONIVEL && (
          <Checkbox
            id={deliveryman._id}
            label={isSelected() ? 'Offline' : 'Online'}
            checked={isSelected()}
            onCheckedChange={() => onSelectedChange()}
          />
        )}
      </Table.Cell>
    </Table.Row>
  );
}

export { DeliverymanRowTable };
